import { Component, HostBinding, Input, OnInit, Optional, Self } from '@angular/core';
import { ControlValueAccessor, UntypedFormBuilder, UntypedFormGroup, FormGroupDirective, NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { SwissFieldBase } from '../../fields/swiss-field-base';

@Component({
  selector: 'app-custom-form-field-control',
  templateUrl: './custom-form-field-control.component.html',
  styleUrls: ['./custom-form-field-control.component.scss'],
  providers: [{
    provide: MatFormFieldControl,
    useExisting: CustomFormFieldControlComponent
  }]
})
export class CustomFormFieldControlComponent implements OnInit, MatFormFieldControl<string>, ControlValueAccessor {

  formGrp!: UntypedFormGroup;
  @Input() swissField?: SwissFieldBase<any>;

  static nextId = 0;
  @Input()
  set value(value: string) {
    //this.formGrp.patchValue(value.options.value);
    this.formGrp.controls[this.swissField!.options.key!].patchValue(value);
    this.stateChanges.next();
  }
  get value() {
    return this.formGrp.controls[this.swissField!.options.key!].value;
  }
  stateChanges = new Subject<void>();

  @HostBinding() id = `custom-form-field-id-${CustomFormFieldControlComponent.nextId++}`

  @Input()
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  get placeholder() {
    return this._placeholder;
  }
  private _placeholder!: string;

  focused: boolean = true;
  empty: boolean = true;
  shouldLabelFloat: boolean = true;
  @Input()
  set required(value: boolean) {
    this._required = value;
  }
  get required() {
    return this._required;
  }
  private _required: boolean = false;

  disabled: boolean = false;
  errorState: boolean = false;
  controlType?: string | undefined;
  autofilled?: boolean | undefined;
  userAriaDescribedBy?: string | undefined;

  onChange!: (value:  string) => void;
  onToutch!: () => void

  constructor(@Optional() @Self() public ngControl: NgControl, private fb: UntypedFormBuilder,
              private rootFormGroup: FormGroupDirective, ) {
    if(this.ngControl != null)
      this.ngControl.valueAccessor = this;

    // FormGroup von überliegender Komponente abholen
    this.formGrp = this.rootFormGroup.control;
  }

  writeValue(obj: string): void {
    if(obj) {
      this.value = obj;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onToutch = fn;
  }

  setDescribedByIds(ids: string[]): void {
    //throw new Error('Method not implemented.');
  }
  onContainerClick(event: MouseEvent): void {
    //throw new Error('Method not implemented.');
  }

  ngOnInit(): void {

  }



}
